import * as React from "react";
import { MedicineForListModel } from "../../models";
import MedicinesList from './medicinesList';
import MedicineService from '../../services/medicineService';
import ActiveIngredientService from '../../services/activeIngredientService';
import Spinner from '../../common/components/spinner/spinner';
import Translate from '../../common/functions/translate';
import { MedicineFilterSettings } from "../../models/medicineFilterSettings";
import * as Constants from '../../common/constants';
import AlphabeticalFilter from '../../common/components/alphabeticalFilter/alphabeticalFilter';
import Drawer from '@material-ui/core/Drawer';
import Fab from '@material-ui/core/Fab';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import Growl from '../../common/components/alertMessage/growl';
import * as HelperFunctions from '../../common/functions/helperFunctions';
import { connect } from 'react-redux';
import { ActiveIngredientModel } from "../../models";
import { Accordion, AccordionTab } from 'primereact/accordion';

interface IProps {
	history?: any,
	location?: any,
	topList: number,
	lang: string,
}

interface IState {
	medicines: Array<MedicineForListModel>;
	isLoading: boolean;
	validationMessage: string;
	from: number;
	numberOfRows: number;
	totalRecordsCount: number;
	medicineSettings: MedicineFilterSettings;
	page: number;
	numberOfPages: number;
	drawer: boolean;
	searchText: string;
	activeIngredient: ActiveIngredientModel;
}

const initFrom = 0;
const numberOfRows = 20;

class MedicinesContainer extends React.Component<IProps, IState> {

	medicineService = new MedicineService(this.props.lang);
	activeIngredientService = new ActiveIngredientService();
	messages: any;
	growl: any;

	constructor(props: IProps) {
		super(props);

		this.state = {
			validationMessage: '',
			medicines: new Array<MedicineForListModel>(0),
			isLoading: false,
			from: initFrom,
			numberOfRows: numberOfRows,
			totalRecordsCount: 0,
			medicineSettings: new MedicineFilterSettings(),
			page: 1,
			numberOfPages: 1,
			drawer: false,
			searchText: '',
			activeIngredient: new ActiveIngredientModel()
		};
	}

	// events
	componentDidMount() {
		if (this.props.topList) {
			this.setState({ from: 0, numberOfRows: this.props.topList });
			this.getAllMedicines(0, this.props.topList, true, true);
			return;
		}

		window.addEventListener('scroll', this.onScroll);

		this.getAllFilteredMedicines(true);
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.onScroll);
	}

	onScroll = () => {
		let scrollY = window.scrollY ? window.scrollY : window.pageYOffset;
		if (window.innerHeight + scrollY >= document.body.offsetHeight - 250 &&
			this.state.totalRecordsCount > this.state.medicines.length && !this.state.isLoading) {
			this.paginatorClick({ first: this.state.from + this.state.numberOfRows }, false);
		}
	};

	componentDidUpdate(prevProps) {
		if (prevProps.location && prevProps.location.search != location.search) {
			this.getAllFilteredMedicines(true);
		}
	}

	getAllFilteredMedicines(isInit: boolean) {
		const { medicineSettings } = this.state;
		medicineSettings.alphaIndex = '';
		medicineSettings.name = '';

		let letter = HelperFunctions.getURLParameter('letter');

		if (letter) {
			medicineSettings.alphaIndex = letter + '';
		}

		let searchText = HelperFunctions.getURLParameter('searchText');

		if (searchText) {
			medicineSettings.name = searchText + '';
		}

		let activeIngredient = HelperFunctions.getURLParameter('activeIngredient');

		if (activeIngredient) {
			medicineSettings.activeIngredientId = parseInt(activeIngredient + '');
			this.activeIngredientService.getActiveIngredient(medicineSettings.activeIngredientId, this.props.lang).then(
				(data: any) => {
					this.setState({
						isLoading: false,
						activeIngredient: data
					});
				}
			)
				.catch(error => {
					this.growl.show({ severity: 'error', summary: error.message });
					this.setState({
						isLoading: false
					});
				});
		}

		let page = 1;

		let pageUrl = HelperFunctions.getURLParameter('page') + '';

		if (pageUrl) {
			page = parseInt(pageUrl);
		}

		//let from = (page - 1) * this.state.numberOfRows;

		this.setState({ medicineSettings: { ...medicineSettings }, page: page },
			() => this.getAllMedicines(this.state.from, this.state.numberOfRows, isInit, false));

	}

	// methods
	getAllMedicines(from: number, numberOfRows: number, isInit: boolean, seenCount: boolean) {
		this.setState({
			isLoading: true
		});

		const { medicineSettings } = this.state;

		this.medicineService.getAllMedicines(from, numberOfRows, medicineSettings, this.props.lang, seenCount).then(
			(data: any) => {
				if (isInit) {
					this.setState({
						isLoading: false,
						from: from,
						medicines: data.medicines,
						totalRecordsCount: data.totalRecordsCount,
						numberOfPages: (data.totalRecordsCount % this.state.numberOfRows > 0 ?
							data.totalRecordsCount / this.state.numberOfRows + 1 : data.totalRecordsCount / this.state.numberOfRows)
					});
				}
				else {
					this.setState({
						isLoading: false,
						medicines: [...this.state.medicines, ...data.medicines],
						totalRecordsCount: data.totalRecordsCount,
						numberOfPages: (data.totalRecordsCount % this.state.numberOfRows > 0 ?
							data.totalRecordsCount / this.state.numberOfRows + 1 : data.totalRecordsCount / this.state.numberOfRows)
					});
				}
			})
			.catch(error => {
				this.growl.show({ severity: 'error', summary: error.message });
				this.setState({
					isLoading: false
				});
			});
	}

	paginatorClick = (e, isInit: boolean) => {
		this.setState({ from: e.first }, () => this.getAllFilteredMedicines(isInit));
	}

	// paginataorClick = (page) => {
	// 	const qs = QueryString.parse(location.search);
	// 	qs['page'] = page;
	// 	this.props.history.push(`${Constants.MedicinesUrl}?${QueryString.stringify(qs)}`);
	// }

	handleAlphaIndexChange = (e, letter: string) => {
		this.setState({ from: 0 });
		this.props.history.push(`${Constants.MedicinesUrl}?letter=${encodeURI(letter)}`);
		this.toggleDrawer(false);
	}


	handleChange = (key, value) => {
		this.setState({ searchText: value });
	};

	handleSearchButtonClick = () => {

		const { searchText } = this.state;

		let searchTextTrim = searchText.trim();

		if (searchTextTrim) {
			this.setState({ from: 0 });
			this.props.history.push(`${Constants.MedicinesUrl}?searchText=${encodeURI(searchTextTrim)}`);
			this.toggleDrawer(false);
		}
	}

	handleKeyPress = (e) => {
		if (e.key === 'Enter') {
			this.setState({ from: 0 }, this.handleSearchButtonClick);
			this.toggleDrawer(false);
		}
	}

	toggleDrawer = (open) => {
		this.setState({
			drawer: open
		});
	};

	handleShowAllClick = (event) => {
		event.preventDefault();
		this.setState({
			medicineSettings: new MedicineFilterSettings()
		});
		this.props.history.push('/medicines');
	}

	// render
	public render() {

		const { medicines, isLoading, medicineSettings, totalRecordsCount, numberOfPages, page, searchText, activeIngredient } = this.state;
		let titleText = '';
		let activeIngredientInfo;
		let showAllLink = false;

		if (medicineSettings && medicineSettings.alphaIndex) {
			titleText = ` ${Translate('starts with')} '${medicineSettings.alphaIndex}' `;
			showAllLink = true;
		}

		if (medicineSettings && medicineSettings.name) {
			titleText = ` ${Translate('contain text')} '${medicineSettings.name}' `;
			showAllLink = true;
		}

		if (medicineSettings && medicineSettings.activeIngredientId && activeIngredient.activeIngredientName) {
			showAllLink = true;
			titleText = ` ${Translate('contain')} '${activeIngredient.activeIngredientName}' `;
			activeIngredientInfo =
				<Accordion multiple={true} style={{ margin: '10px 0' }}>
					<AccordionTab header={`${Translate('Information about')} '${activeIngredient.activeIngredientName}'`}>
						{activeIngredient.activeIngredientName ?
							<div style={{ margin: '10px 0' }}>
								{Translate("Name")}: <span style={{ color: '#999' }}>{activeIngredient.activeIngredientName}</span>
							</div> : null
						}
						{activeIngredient.atcCode && activeIngredient.atcCode.atcCode ?
							<div style={{ margin: '10px 0' }}>
								{Translate("ATC code")}: <span style={{ color: '#999' }}>{activeIngredient.atcCode.atcCode}</span>
							</div> : null
						}
						{activeIngredient.molecularFormula ?
							<div style={{ margin: '10px 0' }}>
								{Translate("Мolecular Formula")}: <span style={{ color: '#999' }}>{activeIngredient.molecularFormula}</span>
							</div> : null
						}
						{activeIngredient.image && activeIngredient.image.imageId ?
							<div style={{ margin: '10px 0' }}>
								<img src={`${Constants.apiUrl}/image/openFile/${activeIngredient.image.imageId}/${activeIngredient.image.imageName}`}
									style={{ width: "100%", border: "1px solid #AAA", maxWidth: '300px' }} />
							</div> : null
						}
						{activeIngredient.description ? <div style={{ margin: '10px 0' }}>{activeIngredient.description}</div> : null}
					</AccordionTab>
				</Accordion>
		}

		return (
			<div className="app-content">

				<Growl ref={(el) => this.growl = el} />

				{!this.props.topList ?
					<>
						<h2>{Translate('Medicines')}{titleText}</h2>
					</>
					: null}

				{!this.props.topList ?
					<Fab color="primary" focusRipple={false} aria-label="Search" size="small" onClick={() => this.toggleDrawer(true)} className="floating-action-button">
						<SearchIcon />
					</Fab>
					: null}

				{!isLoading && !this.props.topList ?
					<div className="list-items-count-info">
						<span className='list-items-count-info-number'>{totalRecordsCount}</span> {Translate('ResulFound')}
					</div> : null}

				{showAllLink ?
					<div style={{ margin: '10px 0' }}>
						<a href='/medicines' onClick={(e) => this.handleShowAllClick(e)}>{Translate('All medicines')}</a>
					</div> : null}

				{activeIngredientInfo ? activeIngredientInfo : null}



				<MedicinesList
					medicines={medicines}
					history={this.props.history}
					isTopList={this.props.topList}
				/>

				{isLoading ? <Spinner inlineSpinner={true} /> : null}

				{
					!this.props.topList ?
						<>
							{/* {numberOfPages > 1 ?
							<div style={{ marginBottom: '20px' }}>
								<Paginator numberOfPages={numberOfPages} page={page} paginataorClick={this.paginataorClick} />
							</div>
							: null} */}

							{/* <h4>{Translate('CanNotFindYourMedicine')}</h4> */}
							<Drawer anchor="bottom" open={this.state.drawer} onClose={() => this.toggleDrawer(false)}>
								<div
									tabIndex={0}
									role="button"
								>
									<div className="user-condition-panel drawer-panel">
										<div className="user-condition-filter">
											<h3>{Translate('SearchMedicineInDatabase')}</h3>
											<Paper style={Constants.inputWithButton.root} elevation={1}>
												<InputBase style={Constants.inputWithButton.input} placeholder={Translate('EnterMedicineName')}
													onChange={(e) => this.handleChange('searchByName', e.target['value'])}
													onKeyPress={this.handleKeyPress}
													value={searchText ? searchText : ""}
												/>
												<IconButton
													color="primary"
													style={Constants.inputWithButton.iconButton}
													onClick={this.handleSearchButtonClick}
												>
													<SearchIcon />
												</IconButton>
											</Paper>
										</div>
										<div className="user-condition-filter">
											<h4>{Translate('BrowseAlphabetically')}</h4>
											<AlphabeticalFilter
												handleAlphaIndexChange={this.handleAlphaIndexChange}
												filters={["bg", "en"]}
												buttonStyle={true}
												letterClassName="p-button-secondary p-button-raised"
											/>
										</div>
									</div>
								</div>
							</Drawer>

						</>
						: null
				}
			</div >
		);
	}
}

const mapsStateToProps = state => {
	return {
		lang: state.common.lang
	};
}

export default connect(mapsStateToProps, null)(MedicinesContainer);
